import { useTheme, Box, Typography, LinearProgress, Card, CardContent } from '@mui/material';

const StatCard = ({ icon, label, value, color = 'primary.main', total }) => {
  const theme = useTheme();
  const hexColor = color.split('.').reduce((obj, k) => obj?.[k], theme.palette) ?? color;

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: '12px !important' }}>
        <Box display="flex" alignItems="center" gap={2} mb={1}>
          <Box sx={{ color, display: 'flex', fontSize: 20 }}>{icon}</Box>
          <Typography variant="subtitle2" noWrap sx={{ flex: 1 }}>{label}</Typography>
        </Box>
        <Typography variant="h5" fontWeight="bold" lineHeight={1.8}>{value}</Typography>
        <LinearProgress
          variant="determinate"
          value={total > 0 ? Math.min((value / total) * 100, 100) : 0}
          sx={{
            mt: 1, height: 6, borderRadius: 3,
            bgcolor: 'action.selected',
            '& .MuiLinearProgress-bar': { bgcolor: hexColor, borderRadius: 3 },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default StatCard;
